"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var viewability_framework_1 = require("viewability-framework");
var components_1 = require("./components");
var utils_1 = require("./utils");
__exportStar(require("./stores"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./components"), exports);
__exportStar(require("./types"), exports);
function AdsLoaderPlugin() {
  return {
    name: 'adsLoader',
    onBrowserWrapRootElement: function (context, next) {
      var getAppData = context.getAppData,
        setRootElement = context.setRootElement;
      var stores = getAppData().stores;
      if (utils_1.checkExperimentsForAdsEligibility(stores.experiment)) {
        viewability_framework_1.initializeViewability();
        var RootElementHOC = function (RootElement) {
          var MesoInitWrapper = function (props) {
            return (
              // Wrapping our provider with the RootElement, which contains the Mobx Provider we need
              React.createElement(RootElement, null, React.createElement(components_1.MesoInit, null, props.children || null))
            );
          };
          return MesoInitWrapper;
        };
        setRootElement(RootElementHOC);
      }
      return next(context);
    }
  };
}
exports.default = AdsLoaderPlugin;